import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Paper, Button, CircularProgress } from '@material-ui/core'
import Stepper from './Stepper'
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined'
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined'
import { makeStyles } from '@material-ui/core/styles'
import { useSnackbar } from 'notistack'
import './SignUp.css'
import SignUpFirstCard from './SignUpFirstCard'
import AgencyStep1 from './AgencyStep1'
import AgencyStep2 from './AgencyStep2'
import AgencyStep3 from './AgencyStep3'
import Password from './Password'
import HowDidYouHearAboutUs from './AboutUs'
import AdvertAgencyStep1 from './AdvertStep1'
import AdvertAgencyStep2 from './AdvertStep2'
import AdvertAgencyStep3 from './AdvertStep3'
import { useDispatch, useSelector } from 'react-redux'
import CompleteCard from './CompleteCard'
import { sha256 } from 'js-sha256'
import { validatePhoneNumber } from 'utils/validatePhoneNumber'
import { validateEmail } from 'utils/validateEmail'
import { resetAccountFields } from 'redux/actions'
import appApiUrl from 'utils/apiUrl'
import Copyright from 'components/Copyright/Copyright'

export default function SignUpCardContainer({ count, setCount }) {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [Account, setAccount] = useState('')
  const password = useSelector(state => state.unsaved.signup?.password)
  const {
    accountType,
    registrationNum,
    companyName,
    address,
    contactPerson,
    contactEmail,
    attachment,
    email,
    phoneNumber,
    fullName,
    firstName,
    lastName,
    referral,
    position
  } = useSelector(state => state.signup)
  const { isPhoneValid: isContactNumberValid } = validatePhoneNumber(
    contactPerson
  )
  const { isPhoneValid } = validatePhoneNumber(phoneNumber)
  const fullNameLength = fullName?.trim().split(' ').length
  const invalidFullName =
    !fullName || !(fullNameLength > 1 && fullNameLength <= 3)

  const handleCountClick = () => {
    count === 6 ? setCount(0) : setCount(count + 1)
  }
  const useStyles = makeStyles(theme => ({
    root: {
      margin: '0 2em'
    },
    button: {
      margin: '0em 0 2em',
      width: '100%'
    },
    [theme.breakpoints.down('xs')]: {
      button: {
        margin: count === 1 ? '2em 0 2em' : '0em 0 2em'
      }
    },
    signin: {
      color: 'black',
      textAlign: 'center',
      margin: '1.5em 0',
      fontSize: '0.875rem',
      fontWeight: 600
    }
  }))
  const classes = useStyles()
  const Card = () => {
    if (accountType === 'agency') {
      switch (count) {
        case 0:
          return <SignUpFirstCard />
        case 1:
          return <AgencyStep1 />
        case 2:
          return <AgencyStep2 />
        case 3:
          return <AgencyStep3 />
        case 4:
          return <Password />
        case 5:
          return <HowDidYouHearAboutUs />

        default:
          return <SignUpFirstCard />
      }
    } else {
      switch (count) {
        case 0:
          return <SignUpFirstCard />
        case 1:
          return <AdvertAgencyStep1 />
        case 2:
          return <AdvertAgencyStep2 />
        case 3:
          return <AdvertAgencyStep3 />
        case 4:
          return <Password />
        case 5:
          return <HowDidYouHearAboutUs />

        default:
          return <SignUpFirstCard />
      }
    }
  }
  const Buttons = () => {
    if (accountType === 'agency') {
      switch (count) {
        case 0:
          return (
            <Button
              className={classes.button}
              onClick={() => handleCountClick()}
              variant="contained"
              color="primary"
              disableElevation
              disabled={!accountType}
              startIcon={<CheckOutlinedIcon />}>
              Start
            </Button>
          )
        case 1:
          return (
            <Button
              className={classes.button}
              onClick={() => handleCountClick()}
              variant="contained"
              color="primary"
              disableElevation
              disabled={
                !registrationNum ||
                !companyName ||
                !address ||
                !isContactNumberValid ||
                !validateEmail(contactEmail) ||
                !attachment?.importedFile.type
              }
              endIcon={<ArrowForwardOutlinedIcon />}>
              Next
            </Button>
          )
        case 2:
          return (
            <Button
              className={classes.button}
              onClick={() => handleCountClick()}
              variant="contained"
              color="primary"
              disableElevation
              disabled={invalidFullName || !position}
              endIcon={<ArrowForwardOutlinedIcon />}>
              Next
            </Button>
          )
        case 3:
          return (
            <Button
              className={classes.button}
              onClick={() => handleCountClick()}
              variant="contained"
              color="primary"
              disableElevation
              disabled={!validateEmail(email) || !isPhoneValid}
              endIcon={<ArrowForwardOutlinedIcon />}>
              Next
            </Button>
          )
        case 4:
          return (
            <Button
              className={classes.button}
              onClick={() => handleCountClick()}
              variant="contained"
              color="primary"
              disableElevation
              disabled={!password?.match}
              endIcon={<ArrowForwardOutlinedIcon />}>
              Next
            </Button>
          )

        case 5:
          return (
            <div style={{ display: 'flex' }}>
              <Button
                className={classes.button}
                onClick={() => handleCountClick()}
                color="primary"
                disableElevation>
                Skip
              </Button>
              <Button
                className={classes.button}
                onClick={() => {
                  handleCountClick()
                }}
                variant="contained"
                color="primary"
                disableElevation
                endIcon={<ArrowForwardOutlinedIcon />}>
                Next
              </Button>
            </div>
          )

        default:
          return <SignUpFirstCard />
      }
    } else {
      switch (count) {
        case 0:
          return (
            <Button
              className={classes.button}
              onClick={() => handleCountClick()}
              variant="contained"
              color="primary"
              disableElevation
              disabled={!accountType}
              startIcon={<CheckOutlinedIcon />}>
              Start
            </Button>
          )
        case 1:
          return (
            <Button
              className={classes.button}
              onClick={() => handleCountClick()}
              variant="contained"
              color="primary"
              disableElevation
              disabled={!firstName || !lastName}
              endIcon={<ArrowForwardOutlinedIcon />}>
              Next
            </Button>
          )
        case 2:
          return (
            <Button
              className={classes.button}
              onClick={() => handleCountClick()}
              variant="contained"
              color="primary"
              disableElevation
              disabled={!validateEmail(email) || !isPhoneValid}
              endIcon={<ArrowForwardOutlinedIcon />}>
              Next
            </Button>
          )
        case 3:
          return (
            <Button
              className={classes.button}
              onClick={() => handleCountClick()}
              variant="contained"
              color="primary"
              disableElevation
              disabled={!companyName || !address}
              endIcon={<ArrowForwardOutlinedIcon />}>
              Next
            </Button>
          )
        case 4:
          return (
            <Button
              className={classes.button}
              onClick={() => handleCountClick()}
              variant="contained"
              color="primary"
              disableElevation
              disabled={!password?.match}
              endIcon={<ArrowForwardOutlinedIcon />}>
              Next
            </Button>
          )

        case 5:
          return (
            <div style={{ display: 'flex' }}>
              <Button
                className={classes.button}
                onClick={() => handleCountClick()}
                color="primary"
                disableElevation>
                Skip
              </Button>
              <Button
                className={classes.button}
                onClick={() => handleCountClick()}
                variant="contained"
                color="primary"
                disableElevation
                endIcon={<ArrowForwardOutlinedIcon />}>
                Next
              </Button>
            </div>
          )

        default:
          return <SignUpFirstCard />
      }
    }
  }
  const getLastName = fullName => {
    const name = fullName?.split(' ')
    name.shift()
    return name?.join(' ')
  }
  useEffect(() => {
    setAccount('')
    const myHeaders = new Headers()
    if (accountType === 'advertiser' && count === 6) {
      myHeaders.append('Content-Type', 'application/json')
      const raw = JSON.stringify({
        companyName: companyName ?? '',
        companyAddress: address ?? '',
        firstname: firstName ?? '',
        lastname: lastName ?? '',
        phone: phoneNumber ?? '',
        email: email ?? '',
        password: sha256(password?.password),
        referrer: referral ?? ''
      })
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }
      fetch(`${appApiUrl}users/signupAdvertiser.php`, requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.state) {
            dispatch(resetAccountFields())
          }
          setAccount(result)
        })
        .catch(error => {
          if (error.name === 'AbortError') return
          enqueueSnackbar(error.message, {
            variant: 'error'
          })
        })
    } else if (accountType === 'agency' && count === 6) {
      const formdata = new FormData()
      companyName && formdata.append('companyName', companyName)
      registrationNum && formdata.append('companyId', registrationNum)
      address && formdata.append('companyAddress', address)
      contactPerson && formdata.append('companyPhone', contactPerson)
      contactEmail && formdata.append('companyEmail', contactEmail)

      fullName.split(' ')[0] &&
        formdata.append('firstname', fullName.split(' ')[0])
      fullName.split(' ')[1] &&
        formdata.append('lastname', getLastName(fullName))
      position && formdata.append('position', position)
      email && formdata.append('email', email)
      phoneNumber && formdata.append('phone', phoneNumber)
      formdata.append('password', sha256(password.password))

      fetch(attachment.preview)
        .then(res => res.blob())
        .then(val => {
          formdata.append('document', val, attachment.importedFile.name)
        })
        .then(() => {
          const requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
          }
          fetch(`${appApiUrl}users/signupAgency.php`, requestOptions)
            .then(response => response.json())
            .then(result => {
              if (result.state) {
                dispatch(resetAccountFields())
              }
              setAccount(result)
            })
            .catch(error => {
              if (error.name === 'AbortError') return
              enqueueSnackbar(error.message, {
                variant: 'error'
              })
            })
        })
    }
    // eslint-disable-next-line
  }, [count])
  const completeSignup = () => {
    if (Account.state === undefined || Account.state === null) {
      return (
        <CircularProgress
          style={{
            position: 'fixed',
            top: 'calc(50% - 20px)',
            left: 'calc(50% - 20px)'
          }}
        />
      )
    } else if (!Account.state) {
      enqueueSnackbar(`Login failed, ${Account.response}`, {
        variant: 'error'
      })
      handleCountClick()
    } else if (Account.state) {
      return <CompleteCard count={count} handleCountClick={handleCountClick} />
    }
  }

  return (
    <div className="signuppaper">
      {count < 6 ? (
        <>
          <Paper elevation={7}>
            <div className={classes.root}>
              <Stepper count={count} />
              {Card()}
              {Buttons()}
            </div>
          </Paper>
          <p className={classes.signin}>
            Already a member?{' '}
            <Link to="/signin" style={{ color: 'red' }}>
              Sign in
            </Link>{' '}
            here
          </p>
        </>
      ) : (
        completeSignup()
      )}

      <Copyright />
    </div>
  )
}
